 import { IMSObject, IMSId } from './ims-object';

/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190402 by Jan Brunner
 *     all rights reserved.
 */

export class BillOfQuantitiesPosition extends IMSObject {
  static fromDto(dto: BillOfQuantitiesPositionDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/BillOfQuantitiesPosition'
      },
      dto.label,
      dto.hg,
      dto.og,
      dto.lg,
      dto.ulg,
      dto.boqposnr,
      dto.baskey,
      dto.shortname,
      dto.amount,
      dto.unit,
      dto.billofquantities
        ? new IMSObject(
            dto.billofquantities.id,
            undefined,
            dto.billofquantities.label,
            'ims/BillOfQuantities'
          )
        : undefined,
    );

    if (databag) {
      obj.databag = databag;
    } else {
      obj.databag = dto;
    }
    return obj;
  }

  constructor(
    public readonly id: IMSId,
    label: string,
    public hg: string,
    public og: string,
    public lg: string,
    public ulg: string,
    public boqPosNr: string,
    public basKey: string,
    public shortName: string,
    public amount: number,
    public unit: string,
    public billOfQuantity: IMSObject,
  ) {
    super(id.imsId, id.secondaryId, label, id.objRef);
  }
}

export interface BillOfQuantitiesPositionDTO {
  id: number;
  secondaryid: number;
  label: string;
  hg: string;
  og: string;
  lg: string;
  ulg: string;
  boqposnr: string;
  baskey: string;
  shortname: string;
  amount: number;
  unit: string;
  billofquantities: {
    id: number;
    label: string;
  };
}
